/**
 * Current Beat (Capsule - HOME, NEWS).
 * 
 */

/**
 * Current Beat Slider.
 * Mobile: Slick slider w/dot nav to right.
 * Desktop: Slick slider w/dot nav to right.
 */

// Set up slick slider for current beat news item slides.
let 
	$window = $(window),
	$myBeatSlider = $('.current-beat__items'),
    myBeatSliderSettings = {
        adaptiveHeight: false,
		arrows: false,
		autoplay: true,
    	// centerMode: true,
		// centerPadding:'30px',
    	// cssEase:'ease-out',
		dots: true,
		appendDots: $('.current-beat__dot-nav'),
		fade: true,
		// focusOnSelect:true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
		variableWidth: false,
        responsive: [
			{
				// breakpoint: 1023,
				// settings: 'unslick'
				// settings: {
				// 	centerMode: false,
				// 	infinite: false,
				// 	slidesToShow: 3,
				// 	slidesToScroll: 1,
				// 	swipeToSlide: false,
				// }
			// }, {
			// 	breakpoint: 1350,
			// 	// settings: 'unslick'
			// 	// settings: {
			// 	// }
			}
        ]
    };

function initSlider() {
	// console.log('CURRENT BEAT: initSlider()');
	$myBeatSlider.slick(myBeatSliderSettings);
	// if ($window.width() >= 1024) {
	// 	initDesktopSlider();
	// }
}

exports.init = function () {
	// console.log('CURRENT BEAT: exports.init');
	// Run init methods...

	initSlider();
};